import { Component, inject, type OnDestroy, type OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { DictionaryService } from '@core/locale/dictionary.service'
import { LocaleService } from '@core/locale/locale.service'
import { type Display } from '@core/type/display'
import { type THEME_TYPE } from '@core/type/theme'
import { IS_SET } from '@core/util/check.util'
import { TO_STRING } from '@core/util/string.util'
import { filter, takeWhile, tap } from 'rxjs/operators'

@Component({
  selector: 'app-json-dialog',
  templateUrl: './json-dialog.component.html',
  styleUrls: ['./json-dialog.component.scss']
})
export class JsonDialogComponent implements OnInit, OnDestroy {
  MAT_DIALOG_DATA = inject(MAT_DIALOG_DATA)
  MatDialogRef = inject(MatDialogRef)
  LocaleService = inject(LocaleService)
  DictionaryService = inject(DictionaryService)

  bAlive = false

  themeType: THEME_TYPE = 'primary'

  title = 'JSON'
  message = ''
  json = ''

  display: Display = {
    cache: {
      close: ''
    },
    update: {
      all: () => {
        for (const k of Object.keys(this.display.cache)) {
          this.display.cache[k] = this.DictionaryService.get({ k })
        }
      }
    }
  }

  ngOnInit (): void {
    this.bAlive = true

    this.DictionaryService.mLastRefreshBS.pipe(
      takeWhile(() => this.bAlive),
      filter(mLastRefresh => IS_SET(mLastRefresh)),
      tap(() => { this.display.update.all() })
    ).subscribe()

    const title = this.MAT_DIALOG_DATA.title

    if (IS_SET(title)) {
      this.title = title
    }

    const message = this.MAT_DIALOG_DATA.message

    if (IS_SET(message)) {
      this.message = message
    }

    const json = this.MAT_DIALOG_DATA.json

    if (IS_SET(json)) {
      let fromJson: any
      try { fromJson = JSON.parse(TO_STRING(json)) } catch { }

      this.json = IS_SET(fromJson) ? JSON.stringify(fromJson, undefined, 2) : json
    }

    const themeType = this.MAT_DIALOG_DATA.themeType

    if (IS_SET(themeType)) {
      this.themeType = themeType
    }

    const closeText = this.MAT_DIALOG_DATA.closeText

    if (IS_SET(closeText)) {
      this.display.cache.close = closeText
    }
  }

  ngOnDestroy (): void {
    this.bAlive = false
  }
}
